import React from "react";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";

const Drawer = ({
  isOpen,
  toggle,
  direction,
  children,
  title,
  size = "md",
}) => {
  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction={direction}
      className={"common-sidebar bg-white " + size}
    >
        <OffcanvasHeader className="bg-white" toggle={toggle}>
        {title}
      </OffcanvasHeader>
      <OffcanvasBody className="border-top bg-white">{children}</OffcanvasBody>
    </Offcanvas>
  );
};

export default Drawer;
